__turbopack_context__.v({
  "content-container": "aiwALW_content-container",
  "content-container--wide": "aiwALW_content-container--wide",
  "content-container__content": "aiwALW_content-container__content",
  "content-container__content--wide": "aiwALW_content-container__content--wide",
});
